import validate from 'validate.js'

const constraints = {
  changeCouncelorInput: {
    presence: true,
  }
}

export default (data) => {
  return validate(data, constraints)
}
